"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyLoad = exports.Loader = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Suspense_1 = require("../suspense/Suspense");
exports.Loader = function () {
    var t = react_i18next_1.useTranslation().t;
    return t('Loading');
};
exports.lazyLoad = function (ComponentToLoad) { return function (props) {
    return Suspense_1.withSuspense(react_1.default.createElement(ComponentToLoad, tslib_1.__assign({}, props)));
}; };
//# sourceMappingURL=Loader.js.map